export class OrderGroupRunningTotal {
    
    public groupId : number = -1;

    public units: number = 0;
    
    public weight: number = 0;
    
    public singles: number = 0;
    
    public feet: number = 0;

    public sections: number = 0;   
    
    public track: number = 0;
    
    public hardware: number = 0;

}
